import { CompletedCollectible } from "@/types/highlights"
import { erc721ABI } from "@/util/typechain"
import { BigNumber } from "ethers"
import { parseEther } from "ethers/lib/utils"
import { getChainId } from "@/util/crypto"

import { useAccount, useContractWrite, usePrepareContractWrite } from "wagmi"
import { useSelector } from "react-redux"
import { selectBlog } from "features/blogSlice"
import { useGetMintTotalCost } from "../useGetMintFee"
import { zeroAddress } from "viem"
import { useReaderReferrer } from "hooks/useReferrer"

export default function useMintExistingCollectibleV1(
  collectible: CompletedCollectible
) {
  const enabled = collectible.version === 1

  const chainId = getChainId(collectible.chain)
  const accountData = useAccount()
  const { error: priceError, totalCost } = useGetMintTotalCost({
    collectibleCostWei: parseEther(collectible.costEth.toString()),
    chain: collectible.chain,
    disabled: !enabled,
  })

  const blog = useSelector(selectBlog)
  const referrer = useReaderReferrer(blog.id)

  const { config, error: prepareError } = usePrepareContractWrite({
    address: collectible.contractAddress as "0x${string}",
    abi: erc721ABI,
    chainId,

    // If referrer is present, call the mintWithReferrer method instead.
    functionName: "mintWithReferrer",
    args: [
      accountData.address as `0x${string}`,
      referrer ? referrer : zeroAddress,
    ],

    overrides: {
      value: totalCost as BigNumber | undefined,
    }, // Need to pass this in as eth
    enabled,
  })

  console.log("useMintExistingCollectibleV1", { config, prepareError })

  const writeData = useContractWrite(config)

  return { ...writeData, prepareError, priceError }
}
